import React, { Suspense } from 'react'

import Title from 'components/Title'
import LoadingFullScreen from 'components/loading-full-screen/component'
import FourOhFour from 'components/FourOhFour'

export default function App({ Component, title, ...props }) {
  return (
    <>
      <Title>{title}</Title>
      <Suspense fallback={<LoadingFullScreen />}>
        {Component ? <Component {...props} /> : <FourOhFour />}
      </Suspense>
    </>
  )
}
